import React from 'react';
import {RentalType} from "../../../../constant/CodeSpecNum";
import {useTranslation} from "react-i18next";
import {
    approveRentalRequest, cancelRentalRequest,
    rejectRentalRequest,
    returnRentalRequest
} from "../../../../api/lifecycle/rental/rentalRequestService";
import RentalExtendModal from "../../../../packages/lifecycle/rentalAsset/subPage/RentalExtendModal";
import {handleActiveError, handleActiveToast} from "../../../sonner/ToastBasic";
import {t} from "i18next";

const RentalRequestTableButtonGroup = ({keys, data, item, refresh}) => {
    const {t} = useTranslation();

    const handleReject = async (e) => {
        e.stopPropagation();
        if (window.confirm(t(`confirmRejectRental`))) {
            const data = {
                rentalAssetId: item.rentalAssetId,
                rentalRequestId: item.id,
                rentalType: RentalType.REJECT.value,
            }
            await rejectRentalRequest(data, () => {
                handleActiveToast({message: t(`complete`)});
                refresh();
            }, () => {
                handleActiveError(
                    {
                        message: t(`unableToHandle.message`),
                        description: t(`unableToHandle.statusAlreadyChanged`)
                    });
                refresh();
            });
        }
    }

    const handleReturn = async (e) => {
        e.stopPropagation();
        if (window.confirm(t(`confirmReturnRental`))) {
            const data = {
                rentalAssetId: item.rentalAssetId,
                rentalRequestId: item.id,
            };
            await returnRentalRequest(data, () => {
                handleActiveToast({message: t(`complete`)});
                refresh();
            }, () => {
                handleActiveError(
                    {
                        message: t(`unableToHandle.message`),
                        description: t(`unableToHandle.statusAlreadyChanged`)
                    });
                refresh();
            });
        }
    }

    const handleApprove = async (e) => {
        e.stopPropagation();
        if (window.confirm(t(`confirmRent`))) {
            const data = {
                rentalAssetId: item.rentalAssetId,
                rentalRequestId: item.id,
            };
            await approveRentalRequest(data, () => {
                handleActiveToast({message: t(`complete`)})
                refresh();
            }, () => {
                handleActiveError(
                    {
                        message: t(`unableToHandle.message`),
                        description: t(`unableToHandle.statusAlreadyChanged`)
                    });
                refresh();
            });
        }
    }

    return (
        <>
            {item.rentalType === RentalType.REQUEST.value &&
                <div className={'flex justify-center gap-2'}>
                    <button
                        className={'text-[13px] px-3 py-0.5 rounded-4 border text-white bg-themeDark hover:opacity-90'}
                        onClick={handleApprove}>대여승인</button>
                    <button
                        className={'text-[13px] px-3 py-0.5 rounded-4 border border-red-300 text-red-500 bg-white hover:bg-red-50'}
                        onClick={handleReject}>대여거절</button>
                </div>
            }
            {item.rentalType === RentalType.RENT.value &&
                <div className={'flex justify-center gap-2'}>
                    {!item.extendApproverId &&
                        <RentalExtendModal
                            rentalRequest={{
                                id: item.id,
                                rentalAssetId: item.rentalAssetId,
                                endDate: item.endDate,
                            }}
                            refresh={refresh}
                        />
                    }
                    <button
                        className={'text-[13px] px-3 py-0.5 rounded-4 border border-green-400 text-green-600 bg-white hover:bg-green-50'}
                        onClick={handleReturn}>대여반납</button>
                </div>
            }
        </>
    );
};


const RentalRequestCancelButton = ({keys, value, item, refresh}) => {
    const {t} = useTranslation();
    const handleCancel = async (e) => {
        e.stopPropagation();
        if (window.confirm(t(`confirmRentalRequestCancel`))) {
            const data = {
                rentalAssetId: item.rentalAssetId,
                rentalRequestId: item.id,
            };
            await cancelRentalRequest(data,
                () => {
                    handleActiveToast({message: t(`complete`)});
                    refresh();
                },
                () => {
                    handleActiveError({message: '취소할 수 없습니다.', description: "이미 대여 상태가 변경되었습니다."});
                    refresh();
                }
            )
        }
    }

    return (
        <div className={"flex justify-center ml-2"}>
            {item.rentalType === RentalType.REQUEST.value &&
                <button
                    className={'text-[13px] px-3 py-0.5 rounded-4 border border-red-300 text-red-500 bg-white hover:bg-red-50'}
                    onClick={handleCancel}>
                    신청취소
                </button>
            }
        </div>
    )
}

export {
    RentalRequestTableButtonGroup, RentalRequestCancelButton,
};